export enum AccountType {
    BOOKKEEPING,
    CUSTOMER,
    SUPPLIER,
}